<script lang="ts">
    import { createEventDispatcher, onMount } from 'svelte'
    const dispatch = createEventDispatcher()
    import Fa from 'svelte-fa'
    import { faAngleLeft, faEdit, faPlusCircle, faSave, faTrashAlt } from '@fortawesome/free-solid-svg-icons'
    import { GridButton, GridClass, GridCol, GridColTypeEnum, GridLine } from '../../_common/z/zgrid'
    import Zgrid from '../../_common/z/zgrid.svelte'
    import Zframe from '../../_common/z/zframe.svelte'
    import Zact from '../../_common/z/zact.svelte'
    import { Integration } from '../../../modules/schedulerApi/integrations/integration'
    import type { CreateIntegrationDto } from '../../../modules/schedulerApi/integrations/dto/create-integration.dto'
    import { UpdateIntegrationDto } from '../../../modules/schedulerApi/integrations/dto/update-integration.dto'
    import LoginGoogle from '../../_common/login-google.svelte'
    // ##############################################################################################################

    export let form: boolean = false
    export let integrationId: string = null
    let entity: Integration = new Integration()

    let schedules = []
    async function loadZanduSchedules() {
        schedules = await window.api.schedulers.schedules.getAll()
    }

    let calendars = []
    async function loadGoogleCalendars() {
        console.log('for', entity.integrationId)
        let result = await window.api.schedulers.integrations.getIntegrationCalendars(entity.integrationId)
        if (result.error) {
            console.log('calendars error', calendars)
            calendars = []
        } else {
            calendars = result
        }
        console.log('calendars', calendars)
    }

    async function editEntity(id: string) {
        try {
            show = true
            step = 2
            entity = new Integration()
            entity = await window.api.schedulers.integrations.getOne(id)
            console.log('integration', entity)
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    async function newEntity() {
        entity = new Integration()
        step = 2
    }

    async function createEntity(closeAfterSave: boolean = true) {
        try {
            show = true
            const dto: CreateIntegrationDto = {
                provider: entity.provider,
                providerSchedulerId: entity.providerSchedulerId,
                providerToken: entity.providerToken,
                schedulerId: entity.schedulerId,
                externalLabel: getCalendarLabelById(entity.providerSchedulerId),
            }
            entity = await window.api.schedulers.integrations.create(dto)
            if (closeAfterSave) {
                if (form) dispatch('close')
                await loadEntities()
                step = 1
            }
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }
    async function updateEntity(closeAfterSave: boolean = true) {
        try {
            show = true
            const dto: UpdateIntegrationDto = {
                provider: entity.provider,
                providerSchedulerId: entity.providerSchedulerId,
                providerToken: entity.providerToken,
                schedulerId: entity.schedulerId,
                status: entity.status,
                externalLabel: getCalendarLabelById(entity.providerSchedulerId),
            }
            await window.api.schedulers.integrations.update(entity.integrationId, dto)
            if (closeAfterSave) {
                if (form) dispatch('close')
                await loadEntities()
                step = 1
            }
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    async function saveEntity(closeAfterSave: boolean = true) {
        if (entity.integrationId) {
            await updateEntity(closeAfterSave)
        } else {
            await createEntity(closeAfterSave)
        }
    }

    function getCalendarLabelById(id: string) {
        for (const calendar of calendars) {
            if (calendar.id === id) return calendar.summary
        }
        return ''
    }

    async function loadEntities() {
        try {
            show = true
            step = 1
            if (window.store.token.permissions.super) {
                entities = await window.api.schedulers.integrations.getAll()
            } else {
                entities = await window.api.schedulers.integrations.getAll({ userId: window.store.token.userId })
            }

            console.log('integrations', entities)
            loadGrid()
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    let grid: GridClass = new GridClass()
    function loadGrid() {
        // grid
        grid = new GridClass()
        // grid head
        grid.title = 'Integração'
        grid.subtitle = ''
        grid.cols.push(new GridCol({ content: 'Provedor' }))
        grid.cols.push(new GridCol({ content: 'Conta' }))
        grid.cols.push(new GridCol({ content: 'Nome' }))
        grid.cols.push(new GridCol({ content: 'Data de cadastro', type: GridColTypeEnum.datetime }))
        grid.cols.push(new GridCol({ content: '', type: GridColTypeEnum.button }))
        // grid lines
        for (const item of entities) {
            const btn = new GridButton({
                callback: () => removeEntity(item.integrationId),

                label: 'Excluir',
            })
            let line: GridLine = new GridLine()
            line.slots.push({ content: item.provider })
            line.slots.push({ content: item.providerSchedulerId })
            line.slots.push({ content: item.externalLabel })
            line.slots.push({ content: item.createdAt })
            line.slots.push({ content: [btn] })
            grid.lines.push(line)
        }
    }

    async function removeEntity(id) {
        if (!confirm('Deseja mesmo excluir esta integração?')) {
            return
        }
        try {
            show = true
            await window.api.schedulers.integrations.remove(id)
            await loadEntities()
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    function evaluateError(error) {
        window.error(error)
    }

    function showEntities() {
        step = 1
    }

    let show = false
    let step = 1
    let entities: Integration[] = []

    onMount(async () => {
        await loadZanduSchedules()
        await loadEntities()
        if (form) {
            if (integrationId) {
                await editEntity(integrationId)
            } else {
                await newEntity()
            }
        }
    })

    let showOptions = false
    async function authSuccess(result) {
        const token = await window.api.schedulers.integrations.getGoogleRefreshToken({
            code: result.detail.code,
            redirectUri: result.detail.redirctUri,
        })
        if (token.error) {
            evaluateError('Erro ao conectar com o Google: ' + token.error_description)
            return
        }
        entity.provider = 'google_calendar'
        entity.providerToken = token.refresh_token
        await saveEntity(false)
        await loadGoogleCalendars()
        showOptions = true
    }
</script>

<div>
    {#if step === 1}
        <Zact>
            <div class="spacer" />
            <button class="btn btn-primary" on:click={newEntity}><Fa icon={faPlusCircle} /> Novo</button>
        </Zact>
        <Zgrid class="mt-3" {grid} />
    {/if}
    {#if step === 2}
        <Zact>
            {#if !form}
                <button class="btn btn-secondary" on:click={showEntities}><Fa icon={faAngleLeft} /> Voltar</button>
            {/if}
            <div class="spacer" />
            <button class="btn btn-primary" on:click={() => saveEntity(true)}><Fa icon={faSave} /> Salvar</button>
        </Zact>

        <Zframe title="Integração" class="m-3">
            <div class="grid-form">
                <div class="row">
                    <div class="col">
                        <LoginGoogle
                            on:auth-success={authSuccess}
                            scopes={['https://www.googleapis.com/auth/calendar']}
                            clientId="482161957283-a7efraa0t6gbhteqslj5qgs3k3o0481f.apps.googleusercontent.com"
                        />
                    </div>
                </div>
                {#if showOptions}
                    <div class="row">
                        <div class="col-12">
                            <div class="input-group">
                                <label for="" class="input-group-text">Qual agenda do Zandu deve ser enviada ao Google Calendar</label>
                                <select class="form-select" name="" id="" bind:value={entity.schedulerId}>
                                    <option />
                                    {#each schedules as schedule}
                                        <option value={schedule.scheduleId}>{schedule.label}</option>
                                    {/each}
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <div class="input-group">
                                <label for="" class="input-group-text">Qual agenda do Google Calendar receberá os agendamentos</label>
                                <select class="form-select" name="" id="" bind:value={entity.providerSchedulerId}>
                                    <option />
                                    {#each calendars as calendar}
                                        <option value={calendar.id}>{calendar.summary}</option>
                                    {/each}
                                </select>
                            </div>
                        </div>
                    </div>
                {/if}
            </div>
        </Zframe>
    {/if}
</div>
